import { useState } from 'react'
import { PlusCircleIcon } from 'lucide-react'
import { Button } from '@/shared/ui/Button/Button'
import { useTranslation } from 'react-i18next'
import { CreatePromotionModal } from './Modals/CreatePromotionModal'
import { PromotionsTable } from './PromotionsTable/PromotionsTable'
import { DeletePromotionAlert } from '@/features/Promotion/DeletePromotionAlert'
import { EditPromotionModal } from './Modals/EditPromotionModal'
import { Promotion } from '@/shared/api/topli/TopliApi'

export const PromotionsView = () => {
  const [currentTable, setCurrentTable] = useState<Promotion | null>(null)
  const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const { t } = useTranslation(['promotion'])

  const handleCloseDialog = () => {
    setCurrentTable(null)
    setCreateDialogOpen(false)
    setEditDialogOpen(false)
    setDeleteDialogOpen(false)
  }

  const handleOpenEditModal = (selectedPromotion: Promotion) => {
    setCurrentTable(selectedPromotion)
    setEditDialogOpen(true)
  }

  const handleOpenDeleteModal = (selectedPromotion: Promotion) => {
    setCurrentTable(selectedPromotion)
    setDeleteDialogOpen(true)
  }

  return (
    <div className='flex flex-col md:w-full w-[calc(100%+2.5rem)] md:mx-0 mx-[-1.25rem] bg-white rounded-[1.25rem] shadow-navbar p-4'>
      <PromotionsTable
        onOpenEditModal={handleOpenEditModal}
        onOpenDeleteModal={handleOpenDeleteModal}
        addButtonSlot={
          <Button
            variant='primary'
            color='base'
            size='md'
            onClick={() => setCreateDialogOpen(true)}
            leftIcon={<PlusCircleIcon size={16} />}
          >
            {t('promotion:buttons.new_promotion')}
          </Button>
        }
      />
      <CreatePromotionModal
        dialogProps={{ open: createDialogOpen, onOpenChange: setCreateDialogOpen }}
        onCloseModal={handleCloseDialog}
      />
      {currentTable !== null && (
        <EditPromotionModal
          dialogProps={{ open: editDialogOpen, onOpenChange: setEditDialogOpen }}
          currentPromotionId={currentTable.id}
          onCloseModal={handleCloseDialog}
        />
      )}
      {currentTable !== null && (
        <DeletePromotionAlert
          open={deleteDialogOpen}
          onOpenChange={setDeleteDialogOpen}
          selectPromotionId={currentTable.id}
          onClose={handleCloseDialog}
        />
      )}
    </div>
  )
}
